<template>

  <component :is="notificationDisplayComponent"
             v-bind="$props"
    :notification="safeNotification"
  >

  </component>
 <!--
  <div v-if="notification && finalLayout === 'default'">notification (default</div>
  <div v-if="notification && finalLayout === 'timeline'">notification (timeline)</div>
  <div v-if="notification && finalLayout === 'intro'">notification (intro)</div>
  -->
</template>

<script>
import asyncComponentFactory from "@/client/extensions/modules/asyncComponentFactory";


export default {
  props: {
    layout: {
      type: String,
      default: "default",
    },
    notification: {
      type: [Object, Boolean],
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data: function () {
    let componentTarget = utilities.ucFirst(this.notification.type) + 'NotificationItem';
    let notificationDisplayComponent = asyncComponentFactory(
      `components/notification/notificationItems/${componentTarget}.vue`,
      true
    );
    return {
      supportedLayouts: ["default", "timeline", "intro"],
      notificationDisplayComponent,
    };
  },
  computed: {
    finalLayout() {
      if (this.supportedLayouts.includes(this.layout)) {
        return this.layout;
      }

      return "default";
    },
    safeNotification() {
      return this.notification;
    },
  },
};
</script>

<style scoped lang="scss"></style>
